#nest-notices-container {
  @apply fixed top-12 right-0 z-[100] flex max-h-screen w-full flex-col-reverse p-4 sm:flex-col max-w-[420px];
}



